const FacebookShareButton = ({ title, description, image, productUrl }) => {
  const dynamicUrl = `https://khulo-share.vercel.app/api/share?title=${encodeURIComponent(
    title,
  )}&description=${encodeURIComponent(description)}&image=${encodeURIComponent(
    image,
  )}&url=${encodeURIComponent(productUrl)}`;

  return (
    <button
      onClick={() =>
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(dynamicUrl)}`,
          "_blank",
          "width=600,height=400",
        )
      }
      style={{
        padding: "5px 5px",
        fontSize: "14px",
        backgroundColor: "#04243F",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        width: "80px",
        height: "40px",
        marginBottom: "20px",
      }}
    >
      FB Share
    </button>
  );
};

export default FacebookShareButton;
